import React from 'react';

const SettingsStep = ({ courseData, onInputChange }) => {
  const ToggleSwitch = ({ field, label, description, checked }) => (
    <div className="flex items-center justify-between">
      <div>
        <p className="font-medium text-gray-900">{label}</p>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
      <label className="relative inline-flex items-center cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onInputChange(field, e.target.checked)}
          className="sr-only peer"
        />
        <div className="w-14 h-7 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-green-500"></div>
      </label>
    </div>
  );

  const features = [
    { field: 'allowReviews', label: 'Allow Student Reviews', description: 'Students can leave reviews and ratings' },
    // { field: 'certificateIncluded', label: 'Certificate of Completion', description: 'Issue certificates upon course completion' },
    // { field: 'lifetimeAccess', label: 'Lifetime Access', description: 'Students get lifetime access to course content' },
    // { field: 'supportIncluded', label: 'Q&A Support', description: 'Provide support through Q&A section' }
  ];

  return (
    <div className="p-8 animate-fade-in">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Course Settings</h2>
      
      <div className="space-y-6">
        {/* Publication Status */}
        <div className="bg-gray-50 rounded-2xl p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Publication Settings</h3>
          <ToggleSwitch
            field="isPublished"
            label="Publish Course"
            description="Make course available to students"
            checked={courseData.isPublished}
          />
        </div>

        {/* Course Features */}
        <div className="bg-gray-50 rounded-2xl p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Course Features</h3>
          <div className="space-y-4">
            {features.map((feature) => (
              <ToggleSwitch
                key={feature.field}
                field={feature.field}
                label={feature.label}
                description={feature.description}
                checked={courseData[feature.field]}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsStep;